import api from "../_app/api";
import { SortParam } from "../_app/components/Table/helpers";
import { filtersIdMap } from "../filter/utils";
import { Query } from "../filter/types";
import { ServiceAnalysisColumn, ServiceAnalysisResponse } from "./types";

export const getServiceAnalysisColumns = async (accountId: string) => {
  let { data }: { data: ServiceAnalysisColumn[] } = await api({
    method: "GET",
    url: "/services/columns",
    params: { "account-id": accountId },
  });
  return data;
};

export const getServiceAnalysis = async (
  accountId: string,
  startingToken: string,
  limit: number,
  sort: SortParam[],
  queries: Query[],
  columns: string[],
) => {
  const params = new URLSearchParams();
  params.append("account-id", accountId);
  if (startingToken) params.append("starting-token", startingToken);
  if (sort.length) sort.map((s) => params.append("sort", [s.col, s.dir].join(",")));
  params.append("size", limit.toString());
  queries.forEach((q) => {
    if (q.id === filtersIdMap.SERVICES_BILL_PERIOD) params.append(q.id, q.value.replace("UNBILLED-", ""));
    else params.append(q.id, q.value);
  });
  columns.forEach((c) => params.append("columns", c));
  const { data }: { data: ServiceAnalysisResponse } = await api({
    method: "GET",
    url: "/services",
    params,
  });
  return data;
};

export const getServiceAnalysisFile = async (accountId: string, queries: Query[]) => {
  const params = new URLSearchParams();
  params.append("account-id", accountId);
  queries.forEach((q) => {
    if (q.id === filtersIdMap.SERVICES_BILL_PERIOD) params.append(q.id, q.value.replace("UNBILLED-", ""));
    else params.append(q.id, q.value);
  });
  return api({
    method: "GET",
    url: "/services/export",
    params,
  });
};
